const categories = [
  {
    id: 'condition',
    label: 'Условие',
  },
];

export function dictionaryCategories() {
  return categories;
}

export function getCategoryNameById(category) {
  let item = categories.find((el) => el.id === category);
  if (typeof item === 'undefined') {
    return null;
  }

  return item.label;
}
